/**
 * Piani, limiti feature e default abbonamento (preparazione Stripe).
 * Fonte di verità per pricing UI, gating feature e inizializzazione utente.
 */

// Durata del periodo di prova gratuito.
export const TRIAL_DAYS = 30;

// Definizione dei piani (allineata alla sezione Pricing della landing).
export const PLANS = {
  trial: {
    id: "trial",
    name: "Trial",
    badge: "Inizia qui",
    priceMonthly: 0,
    priceYearly: 0,
    highlighted: false,
    cta: { label: "Inizia gratis", href: "/richiedi-accesso" },
  },
  pro: {
    id: "pro",
    name: "Pro",
    badge: "Più popolare",
    priceMonthly: 19,
    priceYearly: 199,
    yearlySaving: 29, // 19*12 - 199
    highlighted: true,
    cta: { label: "Passa a Pro", href: "/checkout" },
  },
  enterprise: {
    id: "enterprise",
    name: "Enterprise",
    badge: null,
    priceMonthly: null,
    priceYearly: null,
    custom: true,
    highlighted: false,
    cta: { label: "Contattaci", href: "mailto:richieste@forfy.it" },
  },
};

// Elenco feature del piano Pro (mostrate in landing e disponibili durante il Trial).
export const PRO_FEATURES = [
  "Fatture illimitate",
  "Dashboard fiscale completa",
  "Olli AI assistente fiscale",
  "F24 + ravvedimento automatico",
  "Pianificazione incassi soglie",
  "Accesso commercialista",
  "Export PDF report",
  "Supporto prioritario",
];

// Limiti/capacità per tier (per gating futuro). NB: "free" NON è un piano vendibile,
// è lo stato RISTRETTO post-trial (trial scaduto o abbonamento non attivo). Il Trial
// ha le stesse capacità del Pro. `maxInvoices` resta come alias di `invoicesPerMonth`.
export const FEATURE_LIMITS = {
  free: {
    invoicesPerMonth: 3,
    maxInvoices: 3,
    dashboard: false,
    olli: false,
    f24: false,
    sogliaPlanning: false,
    exportPdf: false,
    prioritySupport: false,
    multiUser: false,
    api: false,
    whiteLabel: false,
  },
  trial: {
    invoicesPerMonth: Number.POSITIVE_INFINITY,
    maxInvoices: Number.POSITIVE_INFINITY,
    dashboard: true,
    olli: true,
    f24: true,
    sogliaPlanning: true,
    exportPdf: true,
    prioritySupport: false,
    multiUser: false,
    api: false,
    whiteLabel: false,
  },
  pro: {
    invoicesPerMonth: Number.POSITIVE_INFINITY,
    maxInvoices: Number.POSITIVE_INFINITY,
    dashboard: true,
    olli: true,
    f24: true,
    sogliaPlanning: true,
    exportPdf: true,
    prioritySupport: true,
    multiUser: false,
    api: false,
    whiteLabel: false,
  },
  enterprise: {
    invoicesPerMonth: Number.POSITIVE_INFINITY,
    maxInvoices: Number.POSITIVE_INFINITY,
    dashboard: true,
    olli: true,
    f24: true,
    sogliaPlanning: true,
    exportPdf: true,
    prioritySupport: true,
    multiUser: true,
    api: true,
    whiteLabel: true,
  },
};

// Stato abbonamento di default per un nuovo utente (Trial 30 giorni).
// I timestamp vengono valorizzati server-side (Cloud Function / webhook Stripe).
export const DEFAULT_SUBSCRIPTION = {
  plan: "trial",
  subscriptionStatus: "trial",
  billingCycle: "monthly",
  trialEndsAt: null,
  currentPeriodEnd: null,
  stripeCustomerId: null,
  stripeSubscriptionId: null,
};

// Stripe Price ID (TEST/sandbox) — NON sono segreti (identificano solo il prezzo).
// La secret key vive esclusivamente in Firebase Secret Manager (mai nel frontend).
export const STRIPE_PRICES = {
  monthly: "price_1TqVsYPMnBwcSlDGURpXWAki",
  yearly: "price_1TqWO5PMnBwcSlDGCu2htcS4",
};

// Email con accesso admin (bypass totale: Pro forzato + pannello /admin).
// Fonte di verità lato client per l'override in useSubscription; il ruolo
// "vero" (per le Cloud Functions e le firestore.rules) resta users/{uid}.role.
export const ADMIN_EMAILS = ["matteopanigada@gmail.com"];

// Whitelist statica di fallback (email con accesso Pro forzato senza abbonamento).
// Popolata manualmente in futuro se serve un fallback hardcoded; la fonte dinamica
// e gestibile da UI è la collection Firestore "whitelist" (vedi AdminPage e
// useSubscription, doc id = email in minuscolo).
export const WHITELIST_EMAILS = [];
